export default __webpack_public_path__ + "static/media/cif-sd.1f881fd2.svg";